class SafeLoadScripts extends HTMLElement {
  constructor() {
    super();
  }


  connectedCallback() {
    const scripts = this.querySelectorAll('safe-load-scripts > script');

    scripts.forEach((script) => {
      const key = script.dataset.flowLoadKey;

      const scriptLoaded = window.wetheme.webcomponentRegistry.checkScriptLoaded(key);
      if(!scriptLoaded) {
        const postLoadedScript = document.createElement('script');
        const {src, defer, async, type} = script;
        postLoadedScript.src = src;
        postLoadedScript.defer = defer;
        postLoadedScript.async = async;
        postLoadedScript.type = type;


        this.parentElement.appendChild(postLoadedScript);

      }
    })

  }
}
  
customElements.define('safe-load-scripts', SafeLoadScripts);

// Biket Black November countdown — launches 9 November 2026 at 08:00 SAST.
(function () {
  const launchTime = new Date('2026-11-09T08:00:00+02:00').getTime();

  function startBlackNovemberCountdown() {
    if (document.body.id !== 'black-friday-2026-bicycle-deals-south-africa-biket') return;

    const section = document.querySelector(
      '#MainContent [id^="shopify-section-template--"][id$="__product-grid"]'
    );

    if (!section || section.querySelector('.black-november-holding')) return;

    const holding = document.createElement('div');
    holding.className = 'black-november-holding';
    holding.setAttribute('aria-live', 'polite');
    holding.innerHTML =
      '<p class="black-november-holding__eyebrow">BLACK NOVEMBER</p>' +
      '<h1 class="black-november-holding__title">LOADING…</h1>' +
      '<div class="black-november-countdown" aria-label="Countdown to Black November">' +
        '<div><strong data-countdown-days>00</strong><span>Days</span></div>' +
        '<div><strong data-countdown-hours>00</strong><span>Hours</span></div>' +
        '<div><strong data-countdown-minutes>00</strong><span>Minutes</span></div>' +
        '<div><strong data-countdown-seconds>00</strong><span>Seconds</span></div>' +
      '</div>' +
      '<p class="black-november-holding__message">Our best deals run from 9 November to 30 November.</p>';

    section.appendChild(holding);
    section.classList.add('black-november-countdown-ready');

    const days = holding.querySelector('[data-countdown-days]');
    const hours = holding.querySelector('[data-countdown-hours]');
    const minutes = holding.querySelector('[data-countdown-minutes]');
    const seconds = holding.querySelector('[data-countdown-seconds]');

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function updateCountdown() {
      const remaining = launchTime - Date.now();

      if (remaining <= 0) {
        document.body.classList.add('black-november-live');
        clearInterval(timer);
        return;
      }

      days.textContent = pad(Math.floor(remaining / 86400000));
      hours.textContent = pad(Math.floor((remaining % 86400000) / 3600000));
      minutes.textContent = pad(Math.floor((remaining % 3600000) / 60000));
      seconds.textContent = pad(Math.floor((remaining % 60000) / 1000));
    }

    let timer;
    updateCountdown();
    timer = setInterval(updateCountdown, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startBlackNovemberCountdown, { once: true });
  } else {
    startBlackNovemberCountdown();
  }
})();
